export default __webpack_public_path__ + "static/media/Schematics.efa07f58.png";